import React from 'react';
export var IconEdit = function IconEdit() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18.467",
    height: "18.459",
    viewBox: "0 0 18.467 18.459"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pen",
    d: "M15.934.7a2.479,2.479,0,0,0-3.5,0l-.877.882L2.221,10.906l-.02.02s0,.01-.01.01-.025.03-.035.044-.005,0-.005.01-.015.025-.025.04,0,.01-.01.015-.01.025-.015.04,0,0,0,.01L.026,17.322a.487.487,0,0,0,.119.505.5.5,0,0,0,.352.144.585.585,0,0,0,.159-.025L6.878,15.87s0,0,.01,0a.18.18,0,0,0,.044-.02.018.018,0,0,0,.01,0c.015-.01.035-.02.049-.03s.03-.025.045-.035.01-.005.01-.01.015-.01.02-.02L17.277,5.536a2.479,2.479,0,0,0,0-3.5ZM6.719,14.706,3.271,11.258l8.63-8.63L15.35,6.075ZM2.786,12.174,5.8,15.186,1.275,16.692ZM16.578,4.842l-.525.53L12.6,1.924l.53-.53a1.486,1.486,0,0,1,2.1,0l1.347,1.347A1.491,1.491,0,0,1,16.578,4.842Zm0,0",
    transform: "translate(0.157 0.338)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "0.3"
  }));
};